import { CascaderOptionType } from 'antd/lib/cascader'
import { Country, GroupedCompanyWithLegalEntitiesAndCountries } from '../../types'

export enum CompanySettingsTabs {
  appraisal = 'company-settings-appraisal',
  requests = 'company-settings-meeting-requests',
  reviewer = 'company-settings-reviewer',
  employees = 'company-settings-employees',
  ranking = 'company-settings-ranking',
  cultivatingTalents = 'company-settings-cultivatingTalents',
  pyramids = 'company-settings-pyramids',
  targetTemplate = 'company-settings-target-template',
  targetReports = 'company-settings-target-reports',
  appraisalSeason = 'appraisal-season',
}

export type CompanyCountrySelectorValue = {
  companyId: string
  companyName: string
  country: Country
}

export interface CompanySettingsState {
  storeInitialized: boolean
  companiesWithLegalEntities: GroupedCompanyWithLegalEntitiesAndCountries[]
  companiesForSelection: CascaderOptionType[]
  companySelectionCurrentValue: string[]
  activeTab: string
  selected: CompanyCountrySelectorValue

  initStore: (companiesWithLegalEntities: GroupedCompanyWithLegalEntitiesAndCountries[], initialActiveTab?: CompanySettingsTabs) => void
  setCompaniesWithLegalEntities: (companiesWithLegalEntities: GroupedCompanyWithLegalEntitiesAndCountries[]) => void
  setActiveTab: (activeTab: string) => void
  setSelected: ({ companyId, country }: { companyId: string; country?: Country }) => void
}
